/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { JoinBookingGuestSpacePathParameters } from 'api/actions/join-booking-guest-space/join-booking-guest-space-path-parameters';
import { JoinBookingGuestSpaceResponse } from 'api/actions/join-booking-guest-space/join-booking-guest-space-response';

type JoinBookingGuestSpaceQueryParameters = Record<string, any>;

/**
 * The path of the JoinBookingGuestSpace action.
 */
export const joinBookingGuestSpaceActionPath = new SweetPath<keyof JoinBookingGuestSpacePathParameters>(
  '/reservations/spaces/{id}/join',
  { path: '{param}' }
);

/**
 * Creates a contextualized JoinBookingGuestSpace actions.
 */
export default function createJoinBookingGuestSpaceAction(axios: AxiosInstance) {
  return function joinBookingGuestSpaceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: JoinBookingGuestSpacePathParameters;
    query?: JoinBookingGuestSpaceQueryParameters;
  }) {
    const path = joinBookingGuestSpaceActionPath.insert(parameters);

    return axios.post<JoinBookingGuestSpaceResponse, JoinBookingGuestSpaceResponse>(path, { params: query, headers });
  };
}
